import { connect } from 'react-redux';
import { Fotorama } from '../components/flat_gallery/fotorama';
export var FotoramaContainer = connect(function (state) {
  return {
    builder: state.MVKData.builder,
    isMVKFullScreen: state.MVKState.isFullScreen,
    isOfferCard: state.MVKState.isOfferCard
  };
})(Fotorama);